import script from "./WithdrawCreditCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawCreditCard.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawCreditCard.vue?vue&type=style&index=0&id=60872a4e&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60872a4e"]])

export default __exports__